function initRedactor() {
    if ($('#redactor_content, .redactor_content').length > 0) {
        $('#redactor_content, .redactor_content').css('width', '100%').redactor({
            focus: false,
            toolbarFixed: false,
            plugins: ['counter', 'fontfamily', 'fontsize', 'fontcolor', 'fullscreen'],
            autoresize: false,
            protocol: 'https://',
            pasteBeforeCallback: function (html) {
                return this.clean.stripTags(html);
            },
        });
    }
}
window.addEventListener("load", function() {
    initRedactor();
});
